export const connectionParamsDomainSelector = state => {
  return state.connectionParams;
};



// WEBPACK FOOTER //
// ./src/containers/ReservationConnectionForm/selectors.js